// font-family: ${font};
export const BRAND_FONT = '"Montserrat", sans-serif';
export const APP_FONT = '"Lato", sans-serif';

// font-wieght: ${fontWeight};
export const REGULAR = '400';
export const BOLD = '700';
export const LIGHT = '300';

// font-size: '${fontSize}px'
export const H1_FONT_SIZE = 24 / 10;
export const H2_FONT_SIZE = 16 / 10;
export const H3_FONT_SIZE = 14 / 10;
export const H4_FONT_SIZE = 12 / 10;
export const H5_FONT_SIZE = 10 / 10;

export const P_FONT_SIZE = 12 / 10;
export const BUTTON_FONT_SIZE = 18 / 10;

// line-height: '${lineHeight}px'
export const H1_LINE_HEIGHT = H1_FONT_SIZE * 1;
export const H2_LINE_HEIGHT = H2_FONT_SIZE * 1.5;
export const H3_LINE_HEIGHT = H3_FONT_SIZE * 1.5;
export const H4_LINE_HEIGHT = H4_FONT_SIZE * 1.5;
export const H5_LINE_HEIGHT = H5_FONT_SIZE * 1.5;

export const P_LINE_HEIGHT = P_FONT_SIZE * 1.5;
export const BUTTON_LINE_HEIGHT = BUTTON_FONT_SIZE * 1.5;
